"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import SimpleScene from "./SimpleScene";
import UICarousel from "../ui/UICarousel";

export default class ImageSelectionScene extends SimpleScene {
    constructor() {
        super();

        // Constants.
        this.ARR_DRAW_IT_TEXT_ID = [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8"
        ];
        this.ARR_IMAGE_SPRITE_ID = [];//from legacy project, working around//--
        this._imageLength = this.ARR_DRAW_IT_TEXT_ID.length;

        for (let i = 0; i < this._imageLength; i++) {
            this.ARR_IMAGE_SPRITE_ID.push("image_" + (i + 1));//--
        }

        // Attributes.
        this._titleSprite = null;
        this._titleText = null;

        // UI.
        this._playBtn = null;
        this._prevImageBtn = null;
        this._nextImageBtn = null;
        this._uiCarousel = null;
    }

    init() {

        this._bgSprite = new PIXI.Sprite(Common.assets.getTexture("bg"));//for some reason bg must be created before super is called
        super.init();

        this.imagePrefix = CommonGame.selectedGallery == CommonGame.GALLERY_ID_COLOUR_IT ? "colour_" : "draw_";
        /*
         // Title sprite.
         this._titleSprite = new PIXI.Sprite(Common.assets.getTexture("popup_box_title_bg"));
         this._titleSprite.y = this._titleSprite.height * 0.5;
         this._titleSprite.x = Common.STAGE_WIDTH * 0.5;
         this._titleSprite.anchor = new PIXI.Point(0.5, 0.75);
         this.addChild(this._titleSprite);

         // Title text.

         // Title text.
         let bkText = P3.createText("DRAWINGS", {
         fill: [0xfff8b3, 0xfac109],
         size: "90px",
         wordWrap: true,
         wordWrapWidth: 500,
         stroke: 0x23a838,
         strokeThickness: 14,
         align: "centre"
         });

         this._titleText = P3.createText("DRAWINGS", {
         fill: [0xfff8b3, 0xfac109],
         size: "90px",
         wordWrap: true,
         wordWrapWidth: 500,
         stroke: 0x006130,
         align: "centre",
         strokeThickness: 8
         });

         this._titleText.y = bkText.y = -45;
         this._titleText.anchor = bkText.anchor = new PIXI.Point(0.5, 0.5);
         this._titleSprite.addChild(bkText, this._titleText);
         */
        // Carousel items.
        var arrCarouselItem = [];
        for (let i = 0; i < this._imageLength; i++) {
            // Container.
            var carouselItem = new PIXI.Container();
            carouselItem.scale = new PIXI.Point(0.6, 0.6);
            carouselItem.anchor = new PIXI.Point(0.5, 0.5);

          //  carouselItem.addChild(CommonGame.createCanvasBg());

            // Bg.
            var bgSprite = new PIXI.Sprite(Common.blankTexture);
            bgSprite.anchor = new PIXI.Point(0.5, 0.5);
            bgSprite.width = CommonGame.CANVAS_WIDTH;
            bgSprite.height = CommonGame.CANVAS_HEIGHT;
            bgSprite.tint = 0xffffff;

            carouselItem.addChild(bgSprite);

            let galleryKey = "drawing";
            if (CommonGame.selectedGallery === 1) galleryKey = "colouring";

            // Border.
            var borderSprite = new PIXI.Sprite(Common.assets.getTexture("canvas_" + galleryKey));
            borderSprite.anchor = new PIXI.Point(0.5, 0.5);
            carouselItem.addChild(borderSprite);
            // Sprite.
            var imageSprite = new PIXI.Sprite(Common.assets.getTexture(this.imagePrefix + "image_" + (i + 1)));
            imageSprite.anchor = new PIXI.Point(0.5, 0.5);
            carouselItem.addChild(imageSprite);

            arrCarouselItem.push(carouselItem);
        }

        // UICarousel.
        this._uiCarousel = new UICarousel();
        this._uiCarousel.init(arrCarouselItem);
        this._uiCarousel.signals.onIndexChanged.add(this._onCarouselIndex_Changed, this);
        this._uiCarousel.signals.onItemSelected.add(this._onPlayButton_Click, this);
        this.addChild(this._uiCarousel);

        // Play button.
        let btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("btn_primary_large_off"),
            Common.assets.getTexture("btn_primary_large_over"),
            Common.assets.getTexture("btn_primary_large_down"),
            Common.assets.getTexture("icon_play_large_off")
        );
        this._playBtn = createButton("play_large", "primary_large");
        this._playBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._playBtn.position = new PIXI.Point(
            Common.STAGE_WIDTH * 0.5,
            Common.STAGE_HEIGHT * 0.5 + 220
        );
        this._playBtn.overSoundName = "sfx_ui_rollover_00";
        this._playBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
        this._playBtn.signals.click.addOnce(this._onPlayButton_Click, this);
        this.addChild(this._playBtn);

        // Next image button.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_next_off"),
            Common.assets.getTexture("icon_next_over"),
            Common.assets.getTexture("icon_next_down")
        );

        this._nextImageBtn = new P3.Button(btnStatesAux);
        this._nextImageBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._nextImageBtn.scale = new PIXI.Point(1.5, 1.5);
        this._nextImageBtn.defaultScale = new PIXI.Point(1.5, 1.5);
        this._nextImageBtn.position = new PIXI.Point(
            Common.STAGE_WIDTH * 0.5 + 400,
            Common.STAGE_HEIGHT * 0.5);
        this._nextImageBtn.signals.click.add(this._onNextImageButton_Click, this);
        this.addChild(this._nextImageBtn);

        // Prev image button.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_next_off"),
            Common.assets.getTexture("icon_next_over"),
            Common.assets.getTexture("icon_next_down")
        );

        this._prevImageBtn = new P3.Button(btnStatesAux);
        this._prevImageBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._prevImageBtn.scale = new PIXI.Point(-1.5, 1.5);
        this._prevImageBtn.alpha = 0;

        this._prevImageBtn.defaultScale = new PIXI.Point(-1.5, 1.5);
        this._prevImageBtn.position = new PIXI.Point(
            Common.STAGE_WIDTH * 0.5 - 400,
            Common.STAGE_HEIGHT * 0.5);
        this._prevImageBtn.signals.click.add(this._onPrevImageButton_Click, this);
        this.addChild(this._prevImageBtn);

        this._updateUI();

        super.createSharedControls.call(this);
        this._uiTopBarSharedControls.muteBtn.visible = true;
        this._uiTopBarSharedControls.backBtn.visible = true;
        this._uiTopBarSharedControls.signals.onBackBtn_Click.addOnce(function () {
            this.signals.previous.dispatch(this);
        }, this);
    }

    update() {
        this._uiCarousel.update();
    }

    animateIn() {
       // this._titleSprite.y -= 100;
       // TweenMax.to(this._titleSprite, 1.5, {y: this._titleSprite.y + 100, ease: Elastic.easeOut});

        this._uiCarousel.animateIn();

        this._playBtn.alpha = 0;
        this._playBtn.scale = new PIXI.Point();
        TweenMax.to(this._playBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.2});
        TweenMax.to(this._playBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2});
    }

    _updateUI() {
        // Prev.
        this._prevImageBtn.interactive = this._uiCarousel.selectedIndex > 0;
        TweenMax.to(this._prevImageBtn, 0.25, {alpha: this._prevImageBtn.interactive ? 1 : 0, ease: Sine.easeOut});

        // Next.
        this._nextImageBtn.interactive = this._uiCarousel.selectedIndex < this._imageLength - 1;
        TweenMax.to(this._nextImageBtn, 0.25, {alpha: this._nextImageBtn.interactive ? 1 : 0, ease: Sine.easeOut});
    }

    destroy() {
        super.destroy({children: true});
        TweenMax.killAll();
    }

    //----EVENTS----//

    _onCarouselIndex_Changed() {
        this._updateUI();
    }

    _onPlayButton_Click() {

        CommonGame.selectedImageId = this.ARR_IMAGE_SPRITE_ID[this._uiCarousel.selectedIndex];

        if (CommonGame.selectedGallery === CommonGame.GALLERY_ID_DRAW_IT) {
            CommonGame.drawItTextId = this.ARR_DRAW_IT_TEXT_ID[this._uiCarousel.selectedIndex];
        }

        // Sfx.
        //   Common.audio.playSound("vo_happo_ready_00");

        this.signals.next.dispatch(this);
    }

    _onPrevImageButton_Click() {
        this._uiCarousel.prev();
    }

    _onNextImageButton_Click() {
        this._uiCarousel.next();
    }

}
